'use client';

import { Radio } from '@mui/material';
import { RadioProps } from '@mui/material/Radio';

import { BpCheckedIcon, BpIcon } from './radio.styles';

const StyledRadio = (props: RadioProps) => (
  <Radio disableRipple color='default' checkedIcon={<BpCheckedIcon />} icon={<BpIcon />} {...props} />
);

export default StyledRadio;
